export enum DroppableArea {
    MEMBERS = 'members',
    PARTICIPANTS = 'participants'
}